import axios from "axios";
import { headers, jwt } from "./constants";
import * as yup from "yup";

export interface IPortfolioOwner {
  id?: string;
  name?: string;
  offsetAccount?: number;
  accountantExpense?: number;
  landTax?: number;
  taxRate?: number;
  ownerId?: string;
}

export const portfolioOwnerSchema = yup.object().shape({
  name: yup.string().nullable().required("Name is required"),
});

export let list = async (ownerId?: string) => {
  let hasError = false;
  let response: any = await axios
    .get(process.env.REACT_APP_API_URL + "/portfolioOwner/list/", {
      headers: headers,
      params: { ownerId: ownerId },
    })
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { data: response.data, hasError };
};

export let get = async (id?: string) => {
  let hasError = false;
  let response: any = await axios
    .get(process.env.REACT_APP_API_URL + "/portfolioOwner/get/", {
      headers: headers,
      params: { id: id },
    })
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { data: response.data, hasError };
};

export let create = async (portfolioOwner?: IPortfolioOwner) => {
  let hasError = false;
  await axios
    .post(
      process.env.REACT_APP_API_URL + "/portfolioOwner/create",
      { data: portfolioOwner },
      {
        headers: headers,
      }
    )
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { hasError };
};

export let update = async (portfolioOwner?: IPortfolioOwner) => {
  let hasError = false;
  await axios
    .post(
      process.env.REACT_APP_API_URL + "/portfolioOwner/update",
      { data: portfolioOwner },
      {
        headers: headers,
      }
    )
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { hasError };
};

export let deleteOne = async (portfolioOwner?: IPortfolioOwner) => {
  let hasError = false;
  await axios
    .post(
      process.env.REACT_APP_API_URL + "/portfolioOwner/delete",
      { data: portfolioOwner },
      {
        headers: headers,
      }
    )
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { hasError };
};
